module.exports = __webpack_public_path__ + "Lato-Italic.aa6c0d9021f3eaaeb637.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Italic.ttf
// module id = ../../../../../src/assets/fonts/Lato-Italic.ttf
// module chunks = styles